import gql from 'graphql-tag';

export const GET_PROGRAMRULES_QUERY = gql`
  query getProgramRules($name: String, $typeCodes: [Int!]) {
    programRules(name: $name, typeCodes: $typeCodes) {
       id
    effectiveDate
    programTypeCode
    programTypeCodeString
    name

    acceptTerms {
      id
      name
      text
      pdfLink
      sequence
    }
    }
  }
`;
